import { Abacus } from "core/Abacus.Core";

let ScrollAPI = {
  isElementInViewport: function(el, offset, adjust) {
    var box = el.getBoundingClientRect(),
      elHeight = box.bottom - box.top, //#100: IE doesn't supply "height" with getBoundingClientRect.
      top = this.getScrollTop() + (adjust ? adjust : 0),
      offsetTop =
        this.getOffset(el).top -
        (offset ? this.getViewportHeight() / offset : 0),
      bottom = offsetTop + elHeight;

    return top >= offsetTop && top <= bottom ? true : false;
  },
  getScrollTop: function() {
    return (
      window.pageYOffset ||
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop
    );
  },
  getViewportHeight: function() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  },
  getOffset: function(el) {
    var offsetTop = 0,
      offsetLeft = 0;

    do {
      if (!isNaN(el.offsetTop)) {
        offsetTop += el.offsetTop;
      }
      if (!isNaN(el.offsetLeft)) {
        offsetLeft += el.offsetLeft;
      }
    } while ((el = el.offsetParent));

    return {
      top: offsetTop,
      left: offsetLeft
    };
  },
  progress: function(el) {
    var this_top = Abacus.ScrollAPI.getOffset(el).top,
      height = el.getComputedSize().totalHeight,
      this_bottom = this_top + height,
      percent = 0;

    percent =
      ((this.getScrollTop() - this_top) / (height - this.getViewportHeight())) *
      100;
    return percent;
  }
};

export { ScrollAPI };



// WEBPACK FOOTER //
// ./Javascript/core/classes/scroll/scroll.api.class.js